import './PopoverMultiStep.scss';

import React, { useMemo } from 'react';
import Popover from '@material-ui/core/Popover/Popover';
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state';

import Box from 'components/Box';
import Text from 'components/Text';

import { cxHelpers } from 'util/className';

const { cx, cxEl } = cxHelpers('PopoverMultiStep');

const PopoverMenuOption = ({ option, onClose }) => {
  const {
    paddingLeft,
    color,
    href,
    label,
    onClick,
    doNotClose,
    ...optionProps
  } = option;

  function handleClick() {
    if (!doNotClose) {
      onClose();
    }

    if (onClick) {
      onClick();
    }
  }

  const colorProp = useMemo(() => color || 'neutral700', [color]);
  const paddingLeftProp = useMemo(() => paddingLeft || 12, [paddingLeft]);

  return (
    <Box
      pointer
      onClick={handleClick}
      tag="a"
      block
      href={href}
      ph={paddingLeftProp}
      pv={8}
      bb
      className={cxEl('option')}
      {...optionProps}
    >
      <Text fs12 fw400 color={colorProp}>
        {label}
      </Text>
    </Box>
  );
};

const PopoverMultiStep = ({
  title,
  titleIcon,
  children,
  options,
  onClickTitle,
  body,
  ...props
}) => (
  <PopupState variant="popover" popupId="popover-multi-step">
    {popupState => (
      <>
        <Box {...bindTrigger(popupState)}>{children}</Box>

        <Popover
          {...bindPopover(popupState)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          {...props}
        >
          <Box bg="white" className={cx()}>
            {(title || titleIcon) && (
              <Box
                ph={12}
                pv={4}
                onClick={onClickTitle || undefined}
                pointer={!!onClickTitle}
              >
                <Text fs12 grayXdark>
                  {titleIcon}
                  {titleIcon && title && '  '}
                  {title}
                </Text>
              </Box>
            )}
            {body}
            {options.map((option, i) => (
              <PopoverMenuOption
                key={i}
                option={option}
                onClose={popupState.close}
              />
            ))}
          </Box>
        </Popover>
      </>
    )}
  </PopupState>
);

export default PopoverMultiStep;
